import { List } from 'immutable';

export const ActionTypes = {
	toggleItem: 'TreeBrowser.toggleItem',
};

export function toggleItem(key: string, path: List<string>): { type: string; key: string; path: List<string> } {
	return { type: ActionTypes.toggleItem, key, path };
}
